(function () {
  "use strict";

  var CONTEXT_SELECTOR = "#cpb-product-context";
  var BODY_CLASS = "fmb-standard-monkey-bars-product";
  var INITIALIZED_ATTR = "data-fmb-standard-monkey-bars-ready";

  function isMonkeyBarsProduct() {
    var context = document.querySelector(CONTEXT_SELECTOR);
    if (!context) return false;

    var productType = (context.getAttribute("data-product-type") || "").trim().toLowerCase();
    var isCpb = context.getAttribute("data-is-cpb-product") === "true";

    return productType === "monkey bars" && !isCpb && !document.querySelector("#product-builder");
  }

  function cloneSource(selector) {
    var source = document.querySelector(selector);
    if (!source) return null;

    var clone = source.cloneNode(true);
    clone.removeAttribute("id");
    clone.hidden = false;
    clone.style.removeProperty("display");
    clone.removeAttribute("style");

    return clone;
  }

  function insertAfter(reference, node) {
    if (!reference || !reference.parentNode || !node) return;
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function cleanMoneyText(root) {
    if (!root) return;

    var selectors = [
      ".money",
      ".product__price",
      ".product-single__price",
      "[id^='ProductPrice']",
      ".cpb-recommended-product-price",
      ".cpb-compatible-accessory-price"
    ];

    root.querySelectorAll(selectors.join(",")).forEach(function (el) {
      if (!el || !el.textContent) return;
      el.textContent = el.textContent
        .replace(/\bAUD\b/g, "")
        .replace(/\bA\$/g, "$")
        .replace(/\s+/g, " ")
        .trim();
    });
  }

  function makePanel(title, body, options) {
    if (!body) return null;

    var panel = document.createElement("details");
    panel.className = "fmb-standard-panel";
    if (options && options.className) panel.className += " " + options.className;
    if (options && options.open) panel.open = true;

    var summary = document.createElement("summary");
    summary.className = "fmb-standard-panel__summary";

    var sourceHeading = body.querySelector(".cpb-post-action-title, .cpb-lifestyle-gallery-title");
    var titleText = title || (sourceHeading ? sourceHeading.textContent.trim() : "");

    if (sourceHeading) {
      sourceHeading.remove();
    }

    if (titleText) {
      var heading = document.createElement("span");
      heading.className = "fmb-standard-panel__summary-title";
      heading.textContent = titleText;
      summary.appendChild(heading);
    }

    var bodyWrap = document.createElement("div");
    bodyWrap.className = "fmb-standard-panel__body";

    if (options && options.controlsFor) {
      bodyWrap.appendChild(createTrackControls(options.controlsFor));
    }

    bodyWrap.appendChild(body);
    panel.appendChild(summary);
    panel.appendChild(bodyWrap);

    return panel;
  }

  function createTrackControls(track) {
    var controls = document.createElement("div");
    controls.className = "fmb-standard-panel__controls";

    var prev = document.createElement("button");
    prev.className = "fmb-standard-panel__arrow fmb-standard-panel__arrow--prev";
    prev.type = "button";
    prev.setAttribute("aria-label", "Scroll previous");
    prev.textContent = "\u2039";

    var next = document.createElement("button");
    next.className = "fmb-standard-panel__arrow fmb-standard-panel__arrow--next";
    next.type = "button";
    next.setAttribute("aria-label", "Scroll next");
    next.textContent = "\u203a";

    var scrollTrack = function (direction) {
      var amount = Math.max(260, Math.round(track.clientWidth * 0.78));
      track.scrollBy({ left: direction * amount, behavior: "smooth" });
    };

    prev.addEventListener("click", function () { scrollTrack(-1); });
    next.addEventListener("click", function () { scrollTrack(1); });

    controls.appendChild(prev);
    controls.appendChild(next);

    return controls;
  }

  function enhanceIntro(meta) {
    if (!meta || meta.querySelector(".fmb-standard-stat-grid")) return;

    var statsSource = cloneSource("#cpb-metafield-box-source");
    var statsGrid = statsSource && statsSource.querySelector(".product-stat-grid--inline");
    if (statsGrid) {
      statsGrid.classList.add("fmb-standard-stat-grid");
      var price = meta.querySelector(".product__price, .product-single__price, [id^='ProductPrice']");
      var afterpay = meta.querySelector(".afterpay-paragraph, .product__policies, square-placement, [data-mpid]");
      var reference = afterpay || price;

      if (reference && reference.parentNode) {
        insertAfter(reference, statsGrid);
      } else {
        meta.insertBefore(statsGrid, meta.querySelector(".product-single__form") || null);
      }
    }

    var overview = cloneSource("#cpb-seo-summary-source");
    if (overview) {
      overview.classList.add("fmb-standard-overview-card");
      var stats = meta.querySelector(".fmb-standard-stat-grid");
      if (stats) {
        insertAfter(stats, overview);
      } else {
        meta.insertBefore(overview, meta.querySelector(".product-single__form") || null);
      }
    }

    cleanMoneyText(meta);
  }

  function buildGalleryPanel() {
    var source = document.querySelector("#cpb-lifestyle-gallery-source");
    if (!source || !source.children.length) return null;

    var track = document.createElement("div");
    track.className = "fmb-standard-scroll-track fmb-standard-gallery-track";

    Array.prototype.forEach.call(source.children, function (child) {
      if (!child.matches || !child.matches("img, picture")) return;
      var item = document.createElement("div");
      item.className = "fmb-standard-gallery-item";
      item.appendChild(child.cloneNode(true));
      track.appendChild(item);
    });

    if (!track.children.length) return null;

    return makePanel("Gallery", track, {
      className: "fmb-standard-gallery-panel",
      controlsFor: track
    });
  }

  function buildCompatibleAccessoriesAccordionItem() {
    var source = cloneSource("#cpb-compatible-accessories-source");
    if (!source) return null;

    var track = source.querySelector(".cpb-compatible-accessories-track");
    var heading = source.querySelector(".cpb-post-action-title, .cpb-compatible-accessories-heading");
    var infoWrap = heading && heading.querySelector(".cpb-compatible-accessories-info-wrap");
    var infoClone = infoWrap ? infoWrap.cloneNode(true) : null;

    if (heading) heading.remove();
    if (!source.innerHTML.trim()) return null;

    if (track) track.classList.add("fmb-standard-scroll-track");
    cleanMoneyText(source);

    var search = source.querySelector(".cpb-compatible-accessories-search");
    if (search && track) {
      search.addEventListener("input", function () {
        var query = search.value.trim().toLowerCase();
        track.querySelectorAll(".cpb-compatible-accessory-card").forEach(function (card) {
          var text = (card.textContent || "").toLowerCase();
          card.hidden = query && text.indexOf(query) === -1;
        });
      });
    }

    var item = document.createElement("details");
    item.className = "cpb-product-detail-accordion-item cpb-product-detail-accordion-item--compatible-accessories cpb-compatible-accessories-panel";

    var summary = document.createElement("summary");
    summary.className = "cpb-product-detail-accordion-summary";

    var title = document.createElement("span");
    title.className = "cpb-product-detail-accordion-title cpb-compatible-accessories-title";
    title.appendChild(document.createTextNode("Compatible Accessories"));
    if (infoClone) title.appendChild(infoClone);

    var body = document.createElement("div");
    body.className = "cpb-product-detail-accordion-body cpb-compatible-accessories-body";
    body.appendChild(source);

    summary.appendChild(title);
    item.appendChild(summary);
    item.appendChild(body);

    return item;
  }

  function buildDimensionsShippingAccordionItem() {
    var source = cloneSource("#cpb-dimensions-shipping-source");
    if (!source) return null;

    var heading = source.querySelector(".cpb-post-action-title");
    if (heading) heading.remove();
    if (!source.innerHTML.trim()) return null;

    var item = document.createElement("details");
    item.className = "cpb-product-detail-accordion-item cpb-product-detail-accordion-item--dimensions-shipping";

    var summary = document.createElement("summary");
    summary.className = "cpb-product-detail-accordion-summary";

    var title = document.createElement("span");
    title.className = "cpb-product-detail-accordion-title";
    title.textContent = "Dimensions & Shipping";

    var body = document.createElement("div");
    body.className = "cpb-product-detail-accordion-body cpb-dimensions-shipping-body";
    body.appendChild(source);

    summary.appendChild(title);
    item.appendChild(summary);
    item.appendChild(body);

    return item;
  }

  function buildSourcePanel(selector, className, options) {
    var source = cloneSource(selector);
    if (!source) return null;

    return makePanel(null, source, {
      className: className,
      open: options && options.open
    });
  }

  function bindProductDetailsAccordion(panel) {
    var items = Array.prototype.slice.call(panel.querySelectorAll(".cpb-product-detail-accordion-item"));

    items.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;

        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function formatWhatsIncludedContent(root) {
    if (!root) return;

    root.querySelectorAll(".cpb-whats-included-content").forEach(function (content) {
      if (content.querySelector(".cpb-included-card-grid")) return;

      var richText = content.querySelector(".metafield-rich_text_field") || content;
      var children = Array.prototype.slice.call(richText.children);
      var grid = document.createElement("div");
      var consumed = [];

      grid.className = "cpb-included-card-grid";

      children.forEach(function (child) {
        if (consumed.indexOf(child) !== -1 || !child.matches("ul, ol")) return;

        var firstItem = child.querySelector("li");
        if (!firstItem || !firstItem.textContent.trim()) return;

        var descriptionNodes = [];
        var next = child.nextElementSibling;

        while (next && !next.matches("ul, ol")) {
          if (next.textContent.trim()) descriptionNodes.push(next);
          consumed.push(next);
          next = next.nextElementSibling;
        }

        var card = document.createElement("article");
        card.className = "cpb-included-card";

        var title = document.createElement("h4");
        title.className = "cpb-included-card-title";
        title.innerHTML = firstItem.innerHTML;
        card.appendChild(title);

        if (descriptionNodes.length) {
          var body = document.createElement("div");
          body.className = "cpb-included-card-body";
          descriptionNodes.forEach(function (node) {
            body.appendChild(node.cloneNode(true));
          });
          card.appendChild(body);
        }

        consumed.push(child);
        grid.appendChild(card);
      });

      if (!grid.children.length) return;

      richText.innerHTML = "";
      richText.classList.add("cpb-whats-included-cards-ready");
      richText.appendChild(grid);
    });
  }

  function buildProductDetailsAccordionPanel() {
    var source = cloneSource("#cpb-product-details-accordion-source");
    if (!source) return null;

    var accordion = source.querySelector(".cpb-product-details-accordion");
    if (!accordion || !accordion.children.length) return null;

    var compatibleItem = buildCompatibleAccessoriesAccordionItem();
    if (compatibleItem) accordion.appendChild(compatibleItem);

    var dimensionsItem = buildDimensionsShippingAccordionItem();
    if (dimensionsItem) accordion.appendChild(dimensionsItem);

    var panel = document.createElement("section");
    panel.className = "fmb-standard-panel fmb-standard-product-details-accordion-panel";
    panel.appendChild(accordion);
    formatWhatsIncludedContent(panel);
    bindProductDetailsAccordion(panel);

    return panel;
  }

  function buildPostPanels(productSection) {
    if (!productSection || document.querySelector(".fmb-standard-post-panels")) return;

    var wrapper = document.createElement("div");
    wrapper.className = "fmb-standard-post-panels";

    [
      buildGalleryPanel(),
      buildProductDetailsAccordionPanel(),
      buildSourcePanel("#cpb-product-faqs-source", "fmb-standard-faq-panel")
    ].forEach(function (panel) {
      if (panel) wrapper.appendChild(panel);
    });

    if (!wrapper.children.length) return;

    insertAfter(productSection, wrapper);
  }

  function markEnhancementState(productSection) {
    if (!productSection) return;
    productSection.setAttribute(INITIALIZED_ATTR, "true");
    document.body.classList.add(BODY_CLASS);
  }

  function run() {
    if (!isMonkeyBarsProduct()) return;

    var productSection = document.querySelector("#shopify-section-product-template .product-section, .product-section.cpb-basic-product");
    var meta = document.querySelector(".product-single__meta");

    if (!productSection || !meta) return;

    markEnhancementState(productSection);
    enhanceIntro(meta);
    buildPostPanels(productSection.closest(".shopify-section") || productSection);
    cleanMoneyText(document);
  }

  function scheduleRun() {
    window.requestAnimationFrame(run);
  }

  run();
  document.addEventListener("DOMContentLoaded", run, { once: true });
  window.addEventListener("load", run, { once: true });

  setTimeout(run, 250);
  setTimeout(run, 900);
  setTimeout(run, 1800);

  if (window.MutationObserver) {
    new MutationObserver(scheduleRun).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();